

import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import DoctorSideBar from "./Doctor-Sidebar";
import "../../styles/Doctor-ui/Doctor-appointment/Doctor-Appointment-page.css";
import "../../index.css";
import axios, { all } from 'axios';
import { appendErrors } from "react-hook-form";
import { API_DETAILS, COOKIE_KEYS } from "../../App";
import Cookies from "js-cookie";
import Youroheader from "../Youro-header";
import Loader from '../../utils/loader';
import Popup from "reactjs-popup";
import { FaExclamationTriangle } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";

// #d7b8b9
const components =
{
  event: (props) => {
    console.log("advance css components for calender", props);
    const eventtype = props.title;
    // Colours come from design-system.css: Sage marks availability, Mint marks
    // booked blocks. Coral is deliberately not used — it is reserved for the
    // single primary CTA on a screen.
    const isAvailable = eventtype === "Available";
    const centerTextStyles = {
      background: isAvailable
        ? "var(--youro-calendar-available-bg)"
        : "var(--youro-calendar-booked-bg)",
      color: isAvailable
        ? "var(--youro-calendar-available-text)"
        : "var(--youro-calendar-booked-text)",
      height: "100%",
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };
    return <div style={centerTextStyles}>{props.title}</div>;
    //  if(eventtype==="Available")
    //   {
    //     return (
    //              <div style={{background:"#745edf",color:"white",
    //                   height:"100%",textAlign:"center"}}>{props.title}</div>
    //           )
    //   } 
    //  else
    //   {
    //     return (<div style={{background:"#8A6767",color:"white",height:"100%",textAlign:"center"}}>{props.title}</div>) 
    //    }
    //  return null;
  }
};

const localizer = momentLocalizer(moment);

// Earliest/latest hour the availability grid shows. These are hours in the
// browser's own timezone, not a fixed zone — a provider in California sees
// 6am Pacific, not 6am Eastern.
const CALENDAR_START_HOUR = 6;
const CALENDAR_END_HOUR = 23;

function DoctorAppointments() {
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showEventDetails, setShowEventDetails] = useState(false);
  const [createvent, setcreatevent] = useState(true);
  const [selectslot, setselectslot] = useState("Available");
  const [showNotificationPopup_tc, setShowNotificationPopup_tc] = useState(false);

  const handleSelectChange = (event) => {
    setselectslot(event.target.value);
  }

  const handlecreatevent_boolen = () => {
    setNewEvent({ start: null, end: null, title: "", email: "" });
    // setTimeConflict(false);
    
  }
  const handleSelectEvent = (event) => {
    console.log('handleSelectEvent start :: ');
    setSelectedEvent(event);
    setShowEventDetails(true);
  };

  const hidedetails = () => {
    // console.log(selectedEvent);
    setShowEventDetails(false);
  }

  const toggleNotificationPopup = () => {
      setShowNotificationPopup_tc(!showNotificationPopup_tc);
  };




  const [events, setEvents] = useState([]);
  const [calenderapt, setcalenderapt] = useState([]);
  const [isTimeConflict, setTimeConflict] = useState(false);
 
  const doctid = Cookies.get(COOKIE_KEYS.userId);
  const fetching_api_data = async () => {

    //  let type = USER_TYPES.doctor;
    let all_events = [];
    // let doc_events=[];

    const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + API_DETAILS.baseExtension +`/getAvailability/${doctid}`;
    const config = {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': '*',
        'Content-Type': 'application/json'
      }
    };
    try {

      const res = await axios.get(url, config);
      console.log("checking doc availability", res.data);
      // const res.data = res.data;


      if (res.data && res.data.appointments) {
        res.data.appointments.forEach((appointment) => {
          const event = {
            start: new Date(appointment.apptStartTime),
            end: new Date(appointment.apptEndTime),
            title: appointment.patientName,
            id: appointment.apptId,
          };
          all_events.push(event);
        });
      }

      console.log("All events", res.data.appointments);
      if (res.data && res.data.docAvail) {
        res.data.docAvail.forEach((availability) => {
          const event = {
            start: new Date(availability.startTime),
            end: new Date(availability.endTime),
            title: availability.status,
            id: availability.doctorId,
          };
          all_events.push(event);
        });
      }

      console.log("all events of docavail ", all_events)

      // console.log("printing all events", all_events);
      setEvents(all_events);
      console.log("printing events after fetching", all_events);
      return all_events;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

   const handleCancelApptAPI = async (selectedEvent) => {
    console.log('handleCancelApptAPI :: ', selectedEvent);

    // Check if the appointment's start time is in the future
    const currentTime = new Date();
    const appointmentStartTime = new Date(selectedEvent.start);
    if (appointmentStartTime <= currentTime) {
        // If the appointment's start time is not in the future, do not allow cancellation
        //alert("Cannot cancel past appointments.");
        toast.error("Cannot cancel past appointments");
        return;
    }

    console.log(typeof (selectedEvent.apptId));
    const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + API_DETAILS.baseExtension +`/cancelAppointment/${selectedEvent.id}/${doctid}`;
    const config = {
      headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': '*',
          'Content-Type': 'application/json'
      }
  };
    try {
      const res = await axios.put(url, config);
      console.log(res);
      hidedetails();
      fetching_api_data();
    }
    catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetching_api_data();
  }, []);

  // react-big-calendar does not scroll its time grid while you drag a selection
  // past the visible edge, so availability could only be dragged as far as the
  // current scroll position happened to show. Nudge the grid when the pointer
  // nears either edge during a drag.
  useEffect(() => {
    const EDGE_ZONE = 48; // px from the edge that starts scrolling
    const SPEED = 12; // px per animation frame
    let grid = null;
    let direction = 0;
    let frame = null;

    const stepScroll = () => {
      if (grid && direction !== 0) {
        grid.scrollTop += direction * SPEED;
        frame = requestAnimationFrame(stepScroll);
      } else {
        frame = null;
      }
    };

    const onMouseMove = (e) => {
      if (!grid) return;
      const box = grid.getBoundingClientRect();
      if (e.clientY > box.bottom - EDGE_ZONE) direction = 1;
      else if (e.clientY < box.top + EDGE_ZONE) direction = -1;
      else direction = 0;
      // Scroll on the move itself so the grid responds to every pointer event,
      // then let the frame loop keep it going while the pointer is held still.
      if (direction !== 0) {
        grid.scrollTop += direction * SPEED;
        if (frame === null) frame = requestAnimationFrame(stepScroll);
      }
    };

    const onMouseDown = (e) => {
      grid = e.target.closest(".rbc-time-content");
      if (grid) document.addEventListener("mousemove", onMouseMove);
    };

    const onMouseUp = () => {
      grid = null;
      direction = 0;
      if (frame !== null) {
        cancelAnimationFrame(frame);
        frame = null;
      }
      document.removeEventListener("mousemove", onMouseMove);
    };

    document.addEventListener("mousedown", onMouseDown);
    document.addEventListener("mouseup", onMouseUp);
    return () => {
      document.removeEventListener("mousedown", onMouseDown);
      document.removeEventListener("mouseup", onMouseUp);
      document.removeEventListener("mousemove", onMouseMove);
      if (frame !== null) cancelAnimationFrame(frame);
    };
  }, []);

  const [newEvent, setNewEvent] = useState({ start: null, end: null, id: "" });

  function handleEventCreation(slotInfo) {
    if (newEvent) {
       
    //  const conflicts = events.filter((event) => {
    //   // const isStartConflict = slotInfo.start >= new Date(event.start) && slotInfo.start <= new Date(event.end);
    //   // const isEndConflict = slotInfo.end >= new Date(event.start) && slotInfo.end <= new Date(event.end);
    //   // const isTitleNotAvailable = event.title !== 'Available';

    //   // return (isStartConflict || isEndConflict) && isTitleNotAvailable;
    //   const isStartConflict = slotInfo.start >= new Date(event.start) && slotInfo.start < new Date(event.end);
    //   const isEndConflict = slotInfo.end > new Date(event.start) && slotInfo.end <= new Date(event.end);

    //   // Check for conflict
    //   if (isStartConflict || isEndConflict) {
    //     return event.title !== 'Available'; // Only consider non-'Available' events as conflicts
    //   }
     
  

    //   return false;
    // });
    const conflicts = events.filter((event) => {
      // const isStartConflict = slotInfo.start >= new Date(event.start) && slotInfo.start < new Date(event.end);
      // const isEndConflict = slotInfo.end > new Date(event.start) && slotInfo.end <= new Date(event.end);


      // const isStartConflict = slotInfo.start >= new Date(event.start) && slotInfo.start < new Date(event.end);
      // const isEndConflict = slotInfo.end > new Date(event.start) && slotInfo.end <= new Date(event.end);
      // const isWithinEvent = slotInfo.start >= new Date(event.start) && slotInfo.end <= new Date(event.end);
      // return (isStartConflict || isEndConflict || isWithinEvent) && event.title !== 'Available';
      
      const eventStart = new Date(event.start);
      const eventEnd = new Date(event.end);

      return (
             (slotInfo.start >= eventStart && slotInfo.start < eventEnd) ||
             (slotInfo.end > eventStart && slotInfo.end <= eventEnd) ||
             (slotInfo.start <= eventStart && slotInfo.end >= eventEnd)
             ) && event.title !== 'Available';

      // return (isStartConflict || isEndConflict) && event.title !== 'Available';
    });

    const conflict = conflicts.length > 0;
    console.log("printing all the conflicts",conflicts);
    setTimeConflict(conflict);
    // if (isTimeConflict) {
    //   // Show a popup or alert indicating a time conflict
    //   // window.alert('You cannot create an available slot here as there is an appointment scheduled.');
    //      <Popup trigger={<button> Trigger</button>} position="right center">
    //          <div>Popup content here !!</div>
    //     </Popup>
    // } else {
      // No time conflict, set the new event
      // if (newEvent.title.length === 0) {
      //   newEvent.title = selectslot;
      // }
      // Build the slot locally and hand it straight to the save call. setNewEvent
      // is asynchronous, so reading `newEvent` back inside saveNewSchedule got the
      // PREVIOUS selection: the first drag sent "null" and every later drag saved
      // the slot before it. Passing the value explicitly keeps them in step.
      const eventData = {
        start: slotInfo.start,
        end: slotInfo.end,
        doctid: doctid,
      };

      // Saving happens when Confirm is pressed in the popup, not here. The popup
      // is where Available vs Unavailable is chosen, so saving on the drag used
      // whatever had been selected last and made that dropdown meaningless.
      setNewEvent(eventData);
      console.log("new event details", eventData);
      // const eventsToSplit = splitEventIfNecessary(newEvent);
      // console.log("new event",eventsToSplit);
      // setEvents((prevEvents) => [...prevEvents, newEvent]);
      // setNewEvent({ start: null, end: null, title: "", email: "" });
      setcreatevent(false);
      // setTimeConflict(false);
      // setShowNotificationPopup_tc(false);
    }
  }

  // function handleCancelAppt(selectedEvent) {

  //   const url= `http://52.14.33.154:9093/youro/api/v1/cancelAppointment/2/1`
  //   console.log(selectedEvent);
  //   handleCancelApptAPI(selectedEvent);
  //   hidedetails();

  // }

  const RemoveAvailability = async (selectedEvent) => {
    //  axios.defaults.headers.common['Access-Control-Allow-Origin'] = 'http://localhost:3000';
    const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + API_DETAILS.baseExtension +`/removeDoctorAvailability`;
    console.log(selectedEvent);
    const temp = {
      startTime: selectedEvent.start + "",
      endTime: selectedEvent.end + "",
      docId: doctid
    };
    const config = {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': '*',
        'Content-Type': 'application/json'
      }
    };
    try {
      const res = await axios.put(url, temp, config);
      console.log(res);
      console.log("posting removed data", res);
      hidedetails();

      // The backend deletes by matching the exact start/end times. When nothing
      // matches — which is what happens to slots written by the old save bug —
      // it does nothing and still returns success. So confirm against a fresh
      // read rather than trusting the 200.
      const remaining = await fetching_api_data();
      const stillPresent =
        Array.isArray(remaining) &&
        remaining.some(
          (e) =>
            new Date(e.start).getTime() === new Date(selectedEvent.start).getTime() &&
            new Date(e.end).getTime() === new Date(selectedEvent.end).getTime()
        );

      if (stillPresent) {
        toast.error(
          "The server did not remove that slot — its stored times do not match. It may need clearing in the database."
        );
      } else {
        toast.success("Availability removed");
      }
      // setselectslot("Available");
    }
    catch (err) {
      console.error(err);
      toast.error(
        err?.response?.data?.errorMessage ||
          "Could not remove that availability. Please try again."
      );
    }
  }

 

  // `slot` is passed in by handleEventCreation. It falls back to newEvent only
  // for any caller that still relies on state.
  const saveNewSchedule = async (slot = newEvent) => {

    console.log("showing what slot is selected", selectslot);

    // The backend parses these with SimpleDateFormat("EEE MMM dd yyyy HH:mm:ss
    // 'GMT'Z (zzz)"), i.e. exactly a JS Date toString. A missing date used to
    // serialise to the string "null" and throw a ParseException server-side.
    if (!slot || !slot.start || !slot.end) {
      console.error("saveNewSchedule called without a valid slot", slot);
      toast.error("Could not read the selected time. Please try again.");
      return;
    }

    if (selectslot == "Available") {
      // axios.defaults.headers.common['Access-Control-Allow-Origin'] = 'http://localhost:3000';
      const url = API_DETAILS.baseUrl+ API_DETAILS.PORT + API_DETAILS.baseExtension +`/addDoctorAvailability`;

      const temp = {
        startTime: slot.start + "",
        endTime: slot.end + "",
        docId: doctid
      };
      console.log(temp);
      const config = {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': '*',
          'Content-Type': 'application/json'
        }
      };
      try {
        const res = await axios.put(url, temp, config);
        console.log(res);
        console.log("posting available data", res);
        fetching_api_data();
        setTimeConflict(false);
        toast.success("Availability added");
        handlecreatevent_boolen(); // close the popup now the slot is saved
      }
      catch (err) {
        // This used to fail silently, so a rejected slot looked like nothing
        // happened at all.
        console.error(err);
        toast.error(
          err?.response?.data?.errorMessage ||
            "Could not save that availability. Please try again."
        );
      }
    }
    else if (selectslot == "Unavailable") {
      
      RemoveAvailability(slot);
      setselectslot("Available");
      handlecreatevent_boolen(); // close the popup
      // axios.defaults.headers.common['Access-Control-Allow-Origin'] = 'http://localhost:3000';
      // const url = `http://52.14.33.154:9093/youro/api/v1/removeDoctorAvailability`;
      // const temp = {
      //   startTime: newEvent.start + "",
      //   endTime: newEvent.end + "",
      //   docId: doctid
      // };
      // console.log(temp);
      // try {
      //   const res = await axios.put(url,temp);
      //   console.log(res);
      //   console.log("posting unavailable data", res);
      //   fetching_api_data();
      // }
      // catch (err) {
      //   console.error(err);
      // }
    }
  }
  // };


  return (
    <div>
      {/* Nothing on this page mounted a ToastContainer, so every toast raised
          here — including the existing "Cannot cancel past appointments" — was
          created and silently discarded. */}
      <ToastContainer />
      <div className="d-app">
        <div className="sidebar">
          <DoctorSideBar data={'doctor-appointment'} />
        </div>
        <div className="d-calender">
          <Youroheader />
          <div className="d-calender-form">
            <Calendar
              localizer={localizer}
              defaultDate={new Date()}
              defaultView={"week"}
              events={events}
              selectable
              min={new Date().setHours(CALENDAR_START_HOUR, 0, 0)}
              max={new Date().setHours(CALENDAR_END_HOUR, 30, 0)}
              onSelectSlot={(slotInfo) => {
                // Every branch below used to fall through silently, so a slot the
                // calendar refused looked identical to a slot that saved fine.
                // The commonest case by far is picking a time earlier than right
                // now on today's column.
                if (slotInfo.action !== 'select') {
                  // A single click reports 'click'; only a drag reports 'select'.
                  toast.info("Drag across the times you want to open up.");
                  return;
                }

                if (
                  slotInfo.start.getHours() < CALENDAR_START_HOUR ||
                  slotInfo.end.getHours() > CALENDAR_END_HOUR
                ) {
                  toast.error(
                    `Availability can only be set between ${CALENDAR_START_HOUR}:00 and ${CALENDAR_END_HOUR}:00.`
                  );
                  return;
                }

                if (slotInfo.start < new Date()) {
                  toast.error("That time has already passed. Pick a later slot.");
                  return;
                }

                handleEventCreation(slotInfo);
              }}
              onSelectEvent={handleSelectEvent}
              style={{ height: "80vh" }}
              components={components}
            />
            <div className="events-form">
              {newEvent.start && (
                <div className="popup-container-apt">
                  <div className="popup-background-apt"></div>
                  <div className="event-creation-form">
                    {/* {isTimeConflict?<div> <FaExclamationTriangle color="red"/>Adding slot will cancel the existing appointment</div>:<></>} */}
                    <p><span style={{ fontWeight: 'bold' }}>{isTimeConflict ? 
                     (
                           <>
                          <FaExclamationTriangle color="red" />
                          Adding slot will cancel the existing appointment
                          </>
                       ) : (
                         'Adding Slot'
                      )}</span></p>
                    <select
                      style={{ width: '85%' }} className="input-field input-border"
                      value={selectslot}
                      onChange={handleSelectChange}
                    >
                      {/* <option value="no-option">Select</option>  */}
                      <option value="Available">Available</option>
                      <option value="Unavailable">Unavailable</option>
                    </select>
                    <p><span style={{ fontWeight: 'bold' }}>Start: </span>{moment(newEvent.start).format('MMMM Do YYYY, h:mm A')}</p>
                    <p><span style={{ fontWeight: 'bold' }}>End: </span>{moment(newEvent.end).format('MMMM Do YYYY, h:mm A')}</p>
                    {/* <p><span style={{ fontWeight: 'bold' }}>End:</span>{newEvent.start.Date}</p> */}
                    {/* <input
                    type="text"
                    placeholder="Event email"
                    value={newEvent.email}
                    onChange={(e) => setNewEvent({ ...newEvent, email: e.target.value })}
                  /> */}
                    
                    <div className="slot-buttons">
                      {isTimeConflict  && selectslot=="Available"? (<div/>)
                         :(<button className="add-availability" onClick={() => saveNewSchedule(newEvent)}>Confirm
                      </button>)}
                      <button className="add-availability" onClick={handlecreatevent_boolen}>Cancel</button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          {showEventDetails && (
            <div className="popup-container-apt">
              <div className="popup-background-apt"></div>
              <div className="event-details-container">
                <div className="event-details">
                  {selectedEvent.title === "Available" ? (<h3>Available Slot</h3>) :
                    (<h3>{selectedEvent.title}</h3>)}
                  <p>
                    {/* <strong>Date:</strong>{" "} */}
                    {/* <p>start:{selectedEvent.start}</p> */}
                    <p>start:{moment(selectedEvent.start).format('MMMM Do YYYY, h:mm:ss a')}</p>
                    <p>end:{moment(selectedEvent.end).format('MMMM Do YYYY, h:mm:ss a')}</p>
                    {/* <p>end:{selectedEvent.end.toLocaleString()}</p> */}
                  </p>
                  <div className="slot-buttons">
                    {selectedEvent.title === "Available" ?
                      (<div><button className="remove-button" onClick={() => RemoveAvailability(selectedEvent)} > Remove Availability</button></div>) :
                      (<div><button className="remove-button" onClick={() => handleCancelApptAPI(selectedEvent)}> Cancel Appointment</button></div>)
                    }
                    <button className="hide-button" onClick={hidedetails}>Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          )}
        
        {/* {showNotificationPopup_tc && (
        <div className="notification-popup-overlay" onClick={toggleNotificationPopup}>
          <div className="notification-popup" onClick={(e) => e.stopPropagation()} >
               <div>Adding slot here will make existing appointment Cancel .Are you sure to remove appointment and add slot?</div>
          </div>
        </div>
        )} */}
          
          {/* <div className="event-container">
            <h3>All Events:</h3>
            {events.map((event, index) => (
            <div key={index} className="event-item">
            <p>
              <strong>Title:</strong> {event.title}
            </p>
            <p>
            <strong>Date:</strong> {event.start.toLocaleString()} - {event.end.toLocaleString()}
            </p>
            <p>
              <strong>Email:</strong> {event.email}
            </p>
          </div>
      ))}
    </div> */}
        </div>
      </div>
    </div>
  );
}

export default DoctorAppointments;
